let variantIds = [];
let upsellIds = new Set();
// upsellIds.add('47579026686236');
// upsellIds.add("49367099441436"); // Meal Planner App
// upsellIds.add("49367124443420"); // Accountability & Coaching Tool Kit
// upsellIds.add("49367118119196"); // Email Support
upsellIds.add("49530503135516"); // 4 week program v2
upsellIds.add("49521728028956"); // 4 Week Keto Transformation Pass
upsellIds.add("47579026686236"); // Keto Testing Strips
upsellIds.add("47578935394588"); // Keto MCT Oil

class AddToBundle extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      const variantId = this.dataset.variantId;
      const bundleAddedProducts = document.querySelector(
        "bundle-added-products"
      );
      bundleAddedProducts.updateVariants(variantId, "add");
    });
  }
}

customElements.define("add-to-bundle", AddToBundle);

class BundleAddedProducts extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      const target = event.target;

      const indexToRemove = Array.from(
        this.querySelectorAll(".remove-variant")
      ).indexOf(target);
      if (target.classList.contains("remove-variant")) {
        this.updateVariants(0, "remove", indexToRemove);
      }
      if (target.classList.contains("add-shake")) {
        if (event.target.classList.contains("add-shake")) {
          var bundlesCollection = document.querySelector(".bundles-collection");
          if (bundlesCollection) {
            var topOffset = bundlesCollection.getBoundingClientRect().top;

            window.scrollBy({
              top: topOffset + 30,
              behavior: "smooth",
            });
          }
        }
      }
    });
  }
  updateVariants(variantId, method, index) {
    if (variantIds.length < 4 && method === "add") {
      variantIds.push(variantId);
      this.updateImages();
    } else if (method === "remove") {
      variantIds.splice(index, 1);
      this.updateImages();
    }

    const productPrice = 79;
    const oneTimeBundlePriceLabel = document.querySelector(
      "[data-bundle-original-price]"
    );
    const oneTimeProductPriceLabel = document.querySelector(
      "[data-bundle-original-per-pc-price]"
    );
    let discountedProductPrice = productPrice;

    if (variantIds.length >= 4) {
      discountedProductPrice = discountedProductPrice * 0.9;
    } else if (variantIds.length >= 2) {
      discountedProductPrice = discountedProductPrice * 0.95;
    }
    const bundlePrice = productPrice * variantIds.length;
    let discountedBundlePrice = 63.712 * variantIds.length;
    const subscribeBundlePrice = discountedBundlePrice * 0.9;
    const savePrice = (66.94 / 4) * variantIds.length;
    // const saveSubscribedPrice = bundlePrice - subscribeBundlePrice;

    if (upsellIds.has("47579026686236")) {
      console.log("has1");
      discountedBundlePrice = discountedBundlePrice + 16.33;
    }
    if (upsellIds.has("47578935394588")) {
      console.log("has2");
      discountedBundlePrice = discountedBundlePrice + 24.15;
    }
    oneTimeBundlePriceLabel.innerHTML = `AUD$${discountedBundlePrice.toFixed(
      2
    )}`;
    // subscribeBundlePriceLabel.innerHTML = `AUD$${subscribeBundlePrice.toFixed(2)}`;

    if (savePrice > 0) {
      oneTimeProductPriceLabel.innerHTML = `(<span>SAVE</span> $${savePrice.toFixed(
        2
      )})`;
      // subscribeProductPriceLabel.innerHTML = `(<span>SAVE</span> $${saveSubscribedPrice.toFixed(2)})`;
    } else {
      oneTimeProductPriceLabel.innerHTML = ``;
      // subscribeProductPriceLabel.innerHTML = ``;
    }
  }

  updateImages() {
    const bundleAddedProducts = document.querySelector("bundle-added-products");
    bundleAddedProducts.innerHTML = "";
    variantIds.forEach(function (variantId, index) {
      const variantContainer = document.querySelector(
        `[data-variant-image-id="${variantId}"`
      );
      const variantImg = variantContainer.querySelector("img");
      const variantImgSrc = variantImg.src;

      const imgContainer = document.createElement("div");
      imgContainer.classList.add("bundle__added-image-wrapper");
      imgContainer.classList.add(
        "bundle__added-image-wrapper",
        "tw-relative",
        "tw-overflow-hidden"
      );

      const newImg = document.createElement("img");
      newImg.classList.add("tw-rounded-xl");
      newImg.src = variantImgSrc;

      imgContainer.appendChild(newImg);

      const removeButton = document.createElement("button");
      removeButton.innerHTML =
        '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="121.31px" height="122.876px" viewBox="0 0 121.31 122.876" enable-background="new 0 0 121.31 122.876" xml:space="preserve"><g><path fill-rule="evenodd" clip-rule="evenodd" d="M90.914,5.296c6.927-7.034,18.188-7.065,25.154-0.068 c6.961,6.995,6.991,18.369,0.068,25.397L85.743,61.452l30.425,30.855c6.866,6.978,6.773,18.28-0.208,25.247 c-6.983,6.964-18.21,6.946-25.074-0.031L60.669,86.881L30.395,117.58c-6.927,7.034-18.188,7.065-25.154,0.068 c-6.961-6.995-6.992-18.369-0.068-25.397l30.393-30.827L5.142,30.568c-6.867-6.978-6.773-18.28,0.208-25.247 c6.983-6.963,18.21-6.946,25.074,0.031l30.217,30.643L90.914,5.296L90.914,5.296z"/></g></svg>';
      removeButton.classList.add("remove-variant");
      removeButton.dataset.variantId = variantId;
      imgContainer.appendChild(removeButton);

      bundleAddedProducts.appendChild(imgContainer);
    });
    if (variantIds.length < 4) {
      const spacerLength = 4 - variantIds.length;
      for (var i = 0; i < spacerLength; i++) {
        const flavorNumber = variantIds.length + i + 1;
        const spacerDiv = document.createElement("div");
        spacerDiv.classList.add(
          "tw-aspect-square",
          "tw-border",
          "tw-border-dashed",
          "tw-border-[#000]",
          "tw-rounded-xl",
          "flex",
          "tw-flex-col",
          "tw-items-center",
          "tw-justify-center",
          "tw-text-center",
          "tw-p-2",
          "add-shake",
          "max-lg:tw-text-xs"
        );
        spacerDiv.textContent = `SELECT FLAVOUR ${flavorNumber}`;
        bundleAddedProducts.appendChild(spacerDiv);
      }
    }
  }
}

customElements.define("bundle-added-products", BundleAddedProducts);

class BundleUpsell extends HTMLElement {
  constructor() {
    super();

    const addBtns = this.querySelectorAll("[data-upsell-add]");
    addBtns.forEach((addBtn) => {
      addBtn.addEventListener("click", (event) => {
        event.preventDefault();
        console.log(addBtn.dataset);
        const variantId = addBtn.dataset.upsellAdd;
        console.log(variantId);
        this.updateUpsellProducts(variantId);
      });
    });
  }

  updateUpsellProducts(variantId) {
    if (!upsellIds.has(variantId)) {
      upsellIds.add(variantId);
      console.log("Added:", variantId);

      const bundleAddedProductImage = document.querySelector(
        `[data-upsell-image-id="${variantId}"]`
      );
      console.log(bundleAddedProductImage);
      if (bundleAddedProductImage) {
        // Check if bundleAddedProductImage is not null
        const bundleAddedProductImageContainer =
          bundleAddedProductImage.closest(".bundle__added-upsell-product");
        if (bundleAddedProductImageContainer) {
          // Check if bundleAddedProductImageContainer is not null
          bundleAddedProductImageContainer.style.display = "block";

          // Check if remove button already exists
          if (
            !bundleAddedProductImageContainer.querySelector(
              '.remove-variant[data-variant-id="' + variantId + '"]'
            )
          ) {
            const removeButton = document.createElement("button");
            removeButton.innerHTML =
              '<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" width="121.31px" height="122.876px" viewBox="0 0 121.31 122.876" enable-background="new 0 0 121.31 122.876" xml:space="preserve"><g><path fill-rule="evenodd" clip-rule="evenodd" d="M90.914,5.296c6.927-7.034,18.188-7.065,25.154-0.068 c6.961,6.995,6.991,18.369,0.068,25.397L85.743,61.452l30.425,30.855c6.866,6.978,6.773,18.28-0.208,25.247 c-6.983,6.964-18.21,6.946-25.074-0.031L60.669,86.881L30.395,117.58c-6.927,7.034-18.188,7.065-25.154,0.068 c-6.961-6.995-6.992-18.369-0.068-25.397l30.393-30.827L5.142,30.568c-6.867-6.978-6.773-18.28,0.208-25.247 c6.983-6.963,18.21-6.946,25.074,0.031l30.217,30.643L90.914,5.296L90.914,5.296z"/></g></svg>';
            removeButton.classList.add("remove-variant");
            removeButton.dataset.variantId = variantId;

            bundleAddedProductImageContainer.appendChild(removeButton);

            removeButton.addEventListener("click", (event) => {
              event.preventDefault();
              upsellIds.delete(variantId);
              bundleAddedProductImageContainer.style.display = "none";
            });
          }
        } else {
          console.error("Container not found for variantId:", variantId);
        }
      } else {
        console.error("Image not found for variantId:", variantId);
      }
    } else {
      console.log("Already exists:", variantId);
    }

    const productPrice = 79;
    const oneTimeBundlePriceLabel = document.querySelector(
      "[data-bundle-original-price]"
    );
    const oneTimeProductPriceLabel = document.querySelector(
      "[data-bundle-original-per-pc-price]"
    );
    let discountedProductPrice = productPrice;

    if (variantIds.length >= 4) {
      discountedProductPrice = discountedProductPrice * 0.9;
    } else if (variantIds.length >= 2) {
      discountedProductPrice = discountedProductPrice * 0.95;
    }
    const bundlePrice = productPrice * variantIds.length;
    let discountedBundlePrice = discountedProductPrice * variantIds.length;
    const subscribeBundlePrice = discountedBundlePrice * 0.9;
    const savePrice = bundlePrice - discountedBundlePrice;
    // const saveSubscribedPrice = bundlePrice - subscribeBundlePrice;

    if (upsellIds.has("47579026686236")) {
      console.log("has1");
      discountedBundlePrice = discountedBundlePrice + 16.33;
    }
    if (upsellIds.has("47578935394588")) {
      console.log("has2");
      discountedBundlePrice = discountedBundlePrice + 24.47;
    }
    oneTimeBundlePriceLabel.innerHTML = `AUD$${discountedBundlePrice.toFixed(
      2
    )}`;
    // subscribeBundlePriceLabel.innerHTML = `AUD$${subscribeBundlePrice.toFixed(2)}`;

    if (savePrice > 0) {
      oneTimeProductPriceLabel.innerHTML = `(<span>SAVE</span> $${savePrice.toFixed(
        2
      )})`;
      // subscribeProductPriceLabel.innerHTML = `(<span>SAVE</span> $${saveSubscribedPrice.toFixed(2)})`;
    } else {
      oneTimeProductPriceLabel.innerHTML = ``;
      // subscribeProductPriceLabel.innerHTML = ``;
    }
  }
}

customElements.define("bundle-upsell", BundleUpsell);

class BundleATC extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", async (event) => {
      event.preventDefault();

      let alertMessage = "";

      // Check if upsellIds contain both required ids
      const products = {
        47578935394588: "Keto MCT Oil",
      };

      let missingProducts = [];
      for (const [productId, productName] of Object.entries(products)) {
        if (!upsellIds.has(productId)) {
          missingProducts.push(productName);
        }
      }

      if (missingProducts.length > 0) {
        alertMessage +=
          "Please add the following products: " +
          missingProducts.join(", ") +
          "\n";
      }

      // Calculate the required number of shakes based on the length of variantIds
      const requiredShakes = Math.max(0, 4 - variantIds.length);

      if (requiredShakes > 0) {
        alertMessage += `Please add ${requiredShakes} more shake${
          requiredShakes > 1 ? "s" : ""
        } to complete your bundle.`;
      }

      if (alertMessage) {
        alert(alertMessage);
        return;
      }

      // ---------------------------
      // Helpers
      // ---------------------------
      const addIdsToItemsMap = (itemsMap, ids = []) => {
        ids.forEach((id) => {
          if (!id) return;
          if (itemsMap[id]) itemsMap[id].quantity++;
          else itemsMap[id] = { id, quantity: 1 };
        });
      };

      // ---------------------------
      // 1) Find bundle wrapper (.bundle__form)
      //    (hidden inputs live here)
      // ---------------------------
      const bundleWrap = document.querySelector(".bundle__form");

      const bundleIdInput = bundleWrap?.querySelector('input[name="bundle_id"]');
      const bundleVariantIdInput = bundleWrap?.querySelector(
        'input[name="bundle_variant_id"]'
      );
      const bundleHandleInput = bundleWrap?.querySelector(
        'input[name="bundle_handle"]'
      );
      const bundleChildProductIdInput = bundleWrap?.querySelector(
        'input[name="shake_id"]'
      );
      const bundleChildCollectionIdInput = bundleWrap?.querySelector(
        'input[name="bundle_collection_id"]'
      );

      const hasBundle =
        bundleIdInput?.value &&
        bundleVariantIdInput?.value &&
        bundleHandleInput?.value &&
        window.recharge?.bundle?.getDynamicBundleItems &&
        bundleChildProductIdInput?.value &&
        bundleChildCollectionIdInput?.value;

      // ---------------------------
      // 2) UPSSELL items (ALWAYS normal)
      // ---------------------------
      const upsellItemsMap = {};
      if (upsellIds) addIdsToItemsMap(upsellItemsMap, Array.from(upsellIds));
      const upsellItemsArray = Object.values(upsellItemsMap);

      // ---------------------------
      // 3) MAIN items (bundle OR normal) - ONLY for variantIds
      // ---------------------------
      let mainItemsArray = [];

      try {
        if (hasBundle) {
          // ✅ RECHARGE DYNAMIC BUNDLE PATH (ONLY variantIds)
          const bundleProductData = {
            productId: bundleIdInput.value,
            variantId: bundleVariantIdInput.value,
            handle: bundleHandleInput.value,
          };

          const childProductId = bundleChildProductIdInput.value;
          const childCollectionId = bundleChildCollectionIdInput.value;

          // If variantIds can include duplicates, convert to qty map for selections
          const qtyMap = {};
          variantIds.forEach((vid) => {
            if (!vid) return;
            qtyMap[vid] = (qtyMap[vid] || 0) + 1;
          });

          // NOTE: sellingPlanId must exist in your scope if you need it.
          // If not needed, remove the sellingPlan property entirely.
          const selections = Object.entries(qtyMap).map(([externalVariantId, quantity]) => ({
            collectionId: childCollectionId,
            externalProductId: childProductId,
            externalVariantId,
            quantity,
            ...(typeof sellingPlanId !== "undefined" && sellingPlanId
              ? { sellingPlan: sellingPlanId }
              : {}),
          }));

          const bundle = {
            externalVariantId: bundleProductData.variantId,
            externalProductId: bundleProductData.productId,
            selections,
          };

          const cartItems = await window.recharge.bundle.getDynamicBundleItems(
            bundle,
            bundleProductData.handle
          );

          mainItemsArray = cartItems;
        } else {
          // ✅ NORMAL PATH (ONLY variantIds)
          const mainItemsMap = {};
          addIdsToItemsMap(mainItemsMap, variantIds);
          mainItemsArray = Object.values(mainItemsMap);
        }

        // ---------------------------
        // 4) Final payload: main + upsells
        // ---------------------------
        const payload = {
          items: [...upsellItemsArray, ...mainItemsArray],
        };

        // ---------------------------
        // 5) Add to cart
        // ---------------------------
        const response = await fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(payload),
        });

        const data = await response.json();

        // Handle response data
        document
          .querySelectorAll("[data-minicart-input]")
          .forEach((miniCartInput) => (miniCartInput.checked = true));

        document.body.classList.add("cart-drawer--open");
      } catch (error) {
        console.error("Error:", error);
      }
    });
  }
}
customElements.define("bundle-atc", BundleATC);

document.addEventListener("DOMContentLoaded", function () {
  // var shakeButtons = document.querySelectorAll('.add-shake');

  // shakeButtons.forEach(function(shakeButton) {
  //     shakeButton.addEventListener('click', function() {
  //     var bundlesCollection = document.querySelector('.bundles-collection');
  //     if (bundlesCollection) {
  //         var topOffset = bundlesCollection.getBoundingClientRect().top;

  //         window.scrollBy({
  //             top: topOffset,
  //             behavior: 'smooth'
  //         });
  //         }
  //     });
  // });

  const bundleForm = document.querySelector(".bundle__form");
  const body = document.body;
  let startY;

  body.addEventListener("touchstart", function (e) {
    startY = e.touches[0].clientY;
  });

  body.addEventListener("touchmove", function (e) {
    const touchY = e.touches[0].clientY;
    const deltaY = touchY - startY;

    if (deltaY > 50) {
      // Swipe down
      bundleForm.classList.remove("minimize");
    } else if (deltaY < -50) {
      // Swipe up
      bundleForm.classList.add("minimize");
    }
  });
});
